import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { ReportViewMode } from '@/types/reports';

interface ReportsTabBarProps {
  viewMode: ReportViewMode;
  onViewModeChange: (mode: ReportViewMode) => void;
  disabled?: boolean;
}

export function ReportsTabBar({
  viewMode,
  onViewModeChange,
  disabled = false,
}: ReportsTabBarProps) {
  return (
    <div className="bg-card border border-border rounded-lg p-3">
      {/* Tab Buttons */}
      <div className={cn(
        "flex items-center rounded-lg border border-border overflow-visible",
        disabled && "opacity-50 pointer-events-none"
      )}>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewModeChange('charts')}
          disabled={disabled}
          className={cn(
            "flex-1 rounded-none rounded-l-[calc(var(--radius)-1px)] h-8 px-3 text-xs",
            viewMode === 'charts'
              ? "bg-[#8FB560] text-black hover:bg-[#8FB560]/90"
              : "hover:bg-muted"
          )}
        >
          CHARTS
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewModeChange('summary')}
          disabled={disabled}
          className={cn(
            "flex-1 rounded-none h-8 px-3 text-xs",
            viewMode === 'summary'
              ? "bg-[#8FB560] text-black hover:bg-[#8FB560]/90"
              : "hover:bg-muted"
          )}
        >
          SUMMARY
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewModeChange('compare')}
          disabled={disabled}
          className={cn(
            "flex-1 rounded-none rounded-r-[calc(var(--radius)-1px)] h-8 px-3 text-xs",
            viewMode === 'compare'
              ? "bg-[#8FB560] text-black hover:bg-[#8FB560]/90"
              : "hover:bg-muted"
          )}
        >
          COMPARE
        </Button>
      </div>
    </div>
  );
}
